import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker'; // ← ajoute

// ── Supprime les erreurs bénignes ResizeObserver et HERE Maps ─────────────────
const _originalOnError = window.onerror;
window.onerror = (msg, source, line, col, err) => {
  if (msg?.includes('ResizeObserver')) return true;
  if (msg === 'Script error.')         return true;
  return _originalOnError?.(msg, source, line, col, err);
};

window.addEventListener('error', (event) => {
  if (event.message?.includes('ResizeObserver')) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
  if (event.message === 'Script error.') {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
}, true);

const _originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0]?.includes?.('ResizeObserver')) return;
  _originalConsoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
serviceWorker.unregister(); // ← ajoute